import ReactOriginalIcon from "react-devicons/react/original";
import FlutterOriginalIcon from "react-devicons/flutter/plain";
import NestjsOriginalIcon from "react-devicons/nestjs/original";
import PostgresqlOriginalIcon from "react-devicons/postgresql/plain";
import FastapiOriginalIcon from "react-devicons/fastapi/plain";
import GitOriginalIcon from "react-devicons/git/plain";
import FigmaOriginalIcon from "react-devicons/figma/plain";
import NextjsOriginalIcon from "react-devicons/nextjs/plain";
import TailwindcssOriginalIcon from "react-devicons/tailwindcss/original";
import AndroidstudioOriginalIcon from "react-devicons/androidstudio/plain";
import FirebaseOriginalIcon from "react-devicons/firebase/plain";
import AppwriteOriginalIcon from "react-devicons/appwrite/plain";
import MongoDBOriginalIcon from "react-devicons/mongodb/plain";
import UnityOriginalIcon from "react-devicons/unity/plain";

export const skills = [
    {
        title: "React",
        icon: <ReactOriginalIcon size={20} />,
    },
    {
        title: "Flutter",
        icon: <FlutterOriginalIcon size={20} />,
    },
    {
        title: "Android",
        icon: <AndroidstudioOriginalIcon size={20} />,
    },
    {
        title: "React Native",
        icon: <ReactOriginalIcon size={20} />,
    },
    {
        title: "Postgres",
        icon: <PostgresqlOriginalIcon size={20} />,
    },
    {
        title: "Firebase",
        icon: <FirebaseOriginalIcon size={20} />,
    },
    {
        title: "Appwrite",
        icon: <AppwriteOriginalIcon size={20} />,
    },
    {
        title: "Git",
        icon: <GitOriginalIcon size={20} />,
    },
    {
        title: "Figma",
        icon: <FigmaOriginalIcon size={20} />,
    },
    {
        title: "NestJS",
        icon: <NestjsOriginalIcon size={20} />,
    },
    {
        title: "FastAPI",
        icon: <FastapiOriginalIcon size={20} />,
    },
];

export const skillscat = {
    mobile: [
        {
            title: "Flutter",
            icon: <FlutterOriginalIcon size={20} />,
        },
        {
            title: "Android",
            icon: <AndroidstudioOriginalIcon size={20} />,
        },
        {
            title: "React Native",
            icon: <ReactOriginalIcon size={20} />,
        },
    ],
    web: [
        {
            title: "React",
            icon: <ReactOriginalIcon size={20} />,
        },
        {
            title: "NextJS",
            icon: <NextjsOriginalIcon size={20} />,
        },
        {
            title: "TailwindCSS",
            icon: <TailwindcssOriginalIcon size={20} />,
        },
    ],
    backend: [
        {
            title: "NestJS",
            icon: <NestjsOriginalIcon size={20} />,
        },
        {
            title: "FastAPI",
            icon: <FastapiOriginalIcon />,
        },
        {
            title: "Postgres",
            icon: <PostgresqlOriginalIcon size={20} />,
        },
        {
            title: "MongoDB",
            icon: <MongoDBOriginalIcon size={20} />,
        },
        {
            title: "Firebase",
            icon: <FirebaseOriginalIcon size={20} />,
        },
        {
            title: "Appwrite",
            icon: <AppwriteOriginalIcon size={20} />,
        },
    ],
    other: [
        {
            title: "Figma",
            icon: <FigmaOriginalIcon size={20} />,
        },
        {
            title: "Git",
            icon: <GitOriginalIcon size={20} />,
        },
        {
            title: "Unity",
            icon: <UnityOriginalIcon size={20} />,
        },
    ],
};
